import type React from 'react';

import { toast } from 'react-toastify';

import { useRolePermissionsTranslation } from './i18n';
import { EditPermissions } from '../../../entities/permissions/edit-permissions';
import type { PointPermissions } from '../../../entities/permissions/edit-permissions/types';
import { useGetRole, usePatchRole } from '@vlabs/api/artemy/client';
import type { RoleId } from '@vlabs/api/artemy/model';

interface RolePermissionsProps {
  roleId: RoleId;
}

function RolePermissions({
  roleId,
}: RolePermissionsProps): React.JSX.Element {
  const { t } = useRolePermissionsTranslation();
  const getRole = useGetRole(roleId);
  const patchRole = usePatchRole({
    mutation: {
      onSuccess: () => {
        toast.success(t('toast_success'));
      },
      onError: () => {
        toast.error(t('toast_error'));
      },
    },
  });

  return (
    <EditPermissions
      defaultValues={getRole.data?.permissions as PointPermissions}
      disabled={getRole.isPending}
      onSubmit={(permissions) => {
        patchRole.mutate({
          roleId,
          data: {
            permissions,
          },
        });
      }}
      roleType={getRole.data?.is_system ? 'system' : 'custom'}
    />
  );
}

export { RolePermissions };
